<template>
  <div class="main-box" :style="'background-image:url(' + bg + ')'" >
    <div class="categories-name" v-if="listJson">{{ listJson[classification].bigTitle }}</div>
    <div class="container" v-if="listJson">
      <div class="categories-box">
        <div class="classification-title">
          <span class="title">{{ listJson[classification].title }}</span
          ><img :src="concat" alt="" /><span class="en-title">{{
            listJson[classification].entitle
          }}</span>
        </div>
        <div class="company-container" v-if="classification === 'VR'">
          <div
            class="company-box"
            v-for="item in listJson[classification].children"
            :key="item.name"
            @click="openLink(item.link)"
          >
            <div class="company-name">{{ item.name }}</div>
          </div>
        </div>
        <div class="company-container" v-else>
          <div
            class="company-box"
            v-for="item in listJson[classification].children"
            :key="item.name"
            @click="goVideoPlay(item.name)"
          >
            <div class="company-name">{{ item.rawName }}</div>
          </div>
        </div>
      </div>
    </div>
    <div :class="'mobile-back-icon-box'" @click="backPage">
      <img :src="backIcon" class="back-icon" />
    </div>
  </div>
</template>

<script>
import bg from "../assets/mimages/base64mbg.js";
import concat from "../assets/mimages/concat.png";
// import listJson from "../assets/list.json";
import backIcon from "../assets/icon/back.png";
import {ListJson} from "@/api";

export default {
  name: "Mlist",
  data() {
    return {
      bg,
      backIcon,
      // listJson,
      ListJson,
      concat,
      classification: null,
      listJson:undefined
    };
  },
  props: {},

  methods: {
    openLink(url) {
      if (
        url === "https://ve.cool360.com/CampusDay/index.html" &&
        +new Date().getTime() < new Date("2022/09/06").getTime()
      ) {
        alert("主题日将于2022年9月6日开放，敬请期待");
        return;
      }
      window.open(url);
    },
    backPage() {
      sessionStorage.removeItem("classification");
      this.$router.go(-1);
    },
    goVideoPlay(name) {
      if(name!=""){
        sessionStorage.setItem("videoName", name + ".mp4");
      this.$router.push("videoplay");
      }
      
    },
  },
  async created() {
    if (sessionStorage.getItem("classification")) {
      this.classification = sessionStorage.getItem("classification");
    } else {
      this.$router.push("/");
    }
    await ListJson().then(res=>{
      this.listJson = res
    })
  },

};
</script>

<style lang="scss" scoped>
.main-box {
  position: relative;
  width: 100vw;
  height: 100vh;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 0%;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  overflow: hidden;
  .categories-name {
    position: absolute;
    top: 7vh;
    left: 50%;
    transform: translateX(-50%);
    font-size: 28px;
    font-weight: bold;
    width: 50vw;
    text-align: center;
    color: #fff;
    text-shadow: 1px 1px #081b34;
  }
  .container {
    width: 90.4%;
    height: 85vh;
    margin: 0 auto;
    margin-top: 15vh;
    overflow-y: scroll;
    // background: rgba(255, 255, 255, 0.6);
    &::-webkit-scrollbar {
      display: none;
    }

    .categories-box {
      width: 100%;
      .classification-title {
        display: inline;
        width: 58.26%;
        height: 5.333vw;
        line-height: 5.333vw;
        color: #fff;
        .title {
          line-height: 5.333vw;
          font-size: 5vw;
          font-weight: 600;
          text-shadow: 1px 1px rgba(0, 0, 0, 0.6);
        }
        .en-title {
          line-height: 5.333vw;
          font-size: 2vw;
        }
        img {
          display: inline-block;
          width: 5vw;
          margin-left: 1.6vw;
          margin-right: 1.6vw;
        }
      }
      .company-container {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-top: 5.6vw;
        margin-bottom: 5.6vw;
        width: 100%;
        .company-box {
          display: flex;
          justify-content: center;
          align-items: flex-start;
          align-items: center;
          width: 42.8vw;
          height: 26.267vw;
          background: #ededed;
          border-radius: 8px;
          &:nth-child(n + 3) {
            margin-top: 27px;
          }
          .company-name {
            max-width: 100%;
            min-width: 27.733vw;
            text-align: center;
            width: 80%;
            font-size: 4.4vw;
          }
        }
      }
    }
  }
  .mobile-back-icon-box {
    user-select: none;
    -webkit-user-select: none; /*禁用手机浏览器的用户选择功能 */
    -moz-user-select: none;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 25px;
    top: 20px;
    width: 40px;
    height: 40px;
    background: rgba(0, 0, 0, 0.25);
    border: none;
    border-radius: 50%;
    z-index: 2;
    cursor: pointer;
    img {
      width: 25px;
      height: 25px;
    }
  }
}
</style>